import {
	addMetadataSuffixToUrl,
	getEditorElementsAssetUrl,
	mergeStylableComponentsMetadata,
	registerStylableExtensions,
} from '@wix/thunderbolt-commons'
import { StylableEditor, PanelComponentsMetadata } from '@wix/stylable-panel-drivers'
import { consts } from '@wix/stylable-santa-flatten/cjs'
import { createHttpClient } from '@wix/http-client'

export async function createStylableFactory({
	componentsStylableMetadataUrls,
	staticServerFallbackUrl,
	staticMediaUrl,
}: {
	componentsStylableMetadataUrls: Array<string>
	staticServerFallbackUrl: string
	staticMediaUrl: string
}) {
	const urls = componentsStylableMetadataUrls.map((url) =>
		getEditorElementsAssetUrl(addMetadataSuffixToUrl(url), staticServerFallbackUrl)
	)
	const httpClient = createHttpClient()

	const stylableMetadatum: Array<PanelComponentsMetadata> = ((await Promise.all(
		urls.map(async (url) => {
			const res = await httpClient.get(url)
			return res.data
		})
	)) as any) as Array<PanelComponentsMetadata>

	return () => {
		const stylableMetadata = mergeStylableComponentsMetadata(stylableMetadatum)

		const stylablePanelExperiments = {
			newElementree: true,
		}

		const stylableEditorInstance = new StylableEditor(
			stylableMetadata,
			consts.SITE_ST_CSS_PATH,
			stylablePanelExperiments
		)

		registerStylableExtensions(stylableEditorInstance, staticMediaUrl)

		return stylableEditorInstance
	}
}
